import React from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import getDropdownStyles from './styles'

SelectAic.propTypes = {
  light: PropTypes.bool,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  className: PropTypes.string,
  rest: PropTypes.object,
}

export default function SelectAic({
  light = false,
  isLoading = false,
  placeholder = 'Select',
  onChange = () => {},
  options = [],
  className = 'w-full min-w-[310px] md:w-fit ease-in-out',
  isError = false,
  ...rest
}) {
  return (
    <Select
      classNamePrefix="aic_select"
      placeholder={placeholder}
      isLoading={isLoading}
      isSearchable={false}
      IndicatorSeparator={false}
      options={options}
      onChange={(data) => {
        onChange(data)
      }}
      styles={getDropdownStyles(light, isError)}
      className={`lenis lenis-smooth ${className}`}
      maxMenuHeight={350}
      {...rest}
    />
  )
}
